import React from "react";
import { FiArrowUp } from "react-icons/fi";
import useScrollPosition from "../../hooks/useScrollPosition";

/**
 * BackToTop — appears once the user has scrolled past the first viewport.
 */
export default function BackToTop() {
  const { isScrolled } = useScrollPosition(700);
  if (!isScrolled) return null;
  return (
    <button
      className="back-to-top"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Back to top"
    >
      <FiArrowUp size={20} />
    </button>
  );
}
